import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterAvailableItemsPipe'
})
export class FilterAvailableItemsPipe implements PipeTransform {
  transform(
    availableItem: any,
    options: { initialArray?: any[]; alreadyExistingItems?: any[] }
  ): any[] {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    const array = options.alreadyExistingItems.map(item => item.changeType);

    return options.initialArray.filter(
      type => !array.includes(type.value) || type.value === availableItem
    );
  }
}
